import { Color } from '@kite-js/theme-types';

const red: Color = {
    50: '#ffe2e2',
    100: '#ffbbbb',
    200: '#e26b6b',
    300: '#cc0000',
    400: '#af0000',
    500: '#6f0000',
};

export default red;
